import { render } from "./Menu.vue?vue&type=template&id=75060670&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=75060670&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-75060670"

export default script